export async function cancelTempRequest(tempRequestId: number | string, authenticityToken?: string) {
  const endpoint = `/api/v1/temp_request/${tempRequestId}/cancel`;

  const headers: Record<string, string> = {
    'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  if (authenticityToken) {
    headers['X-CSRF-Token'] = authenticityToken;
  }

  const resp = await fetch(endpoint, {
    method: 'PATCH',
    headers,
    redirect: 'manual'
  });

  const json = await resp.json().catch(() => null);
  return { ok: resp.ok, status: resp.status, body: json };
}


